module.exports = __webpack_public_path__ + "img/android3Bg.5be78e66.png";